// react
import React from "react"
import { connect } from "react-redux"
// app
import Jobs from "components/person/Jobs"

import { getJobs, postJob, putJob, deleteJob } from "actions/profile/jobs/actions.js"


class Step5 extends React.Component {
    constructor(props) {
        super()

        const personid = props.personid

        this.onJobAdd = job => {
            job.personid = personid
            this.props.postJob(job)
        }
        this.onJobEdit = job => this.props.putJob(job)
        this.onJobRemove = id => this.props.deleteJob(id)
    }

    componentDidMount() {
        const personid = this.props.personid

        this.props.getJobs(personid)
    }

    render() {
        return (
            <Jobs
                data={ this.props.jobs }
                onSave={ this.onJobAdd }
                onEdit={ this.onJobEdit }
                onRemove={ this.onJobRemove }
            />
        )
    }
}

const mapStateToProps = state => {
    return {
        jobs: state.profile.jobs.get("data")
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getJobs: personid => dispatch(getJobs(personid)),
        postJob: job => dispatch(postJob(job)),
        putJob: job => dispatch(putJob(job)),
        deleteJob: id => dispatch(deleteJob(id))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Step5)


/** WEBPACK FOOTER **
 ** ./src/containers/Profile/Step5.js
 **/